import ROUTES from "config/routing";
import { FlyerStatus } from "pages/flyer/flyerTypePage/useGetDataForPage";
import { CampaignFlyerInfo } from "store/types";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useParams, generatePath } from "react-router-dom";
import { getCampaignFlyerData } from "../../../graphQL";

export interface UseGetFlyerInfoResponse {
  isLoading: boolean;
  flyerInfo: CampaignFlyerInfo | null;
  pageState: FlyerStatus;
  getFlyerInfo: () => void;
  isQrCodeExist: boolean;
  campaignId: string;
}

export const useGetFlyerInfo = (): UseGetFlyerInfoResponse => {
  const location = useLocation();
  const history = useHistory();
  const isPublicBuilder = location.pathname.includes(`${ROUTES.PUBLIC_FLYER_BUILDER.split("/")[1]}/`);

  const { campaignId, clientId: clientIdParam } = useParams();
  const [flyerInfo, setFlyerInfo] = useState<CampaignFlyerInfo | null>(null);
  const [isQrCodeExist, setIsQrCodeExist] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getPageState = () => {
    if (flyerInfo?.isFlyerUploaded) {
      return FlyerStatus.flyerUploaded;
    } else if (flyerInfo?.isFlyerUploaded === false) {
      return FlyerStatus.flyerCreated;
    }
    return FlyerStatus.flyerAbsent;
  };

  if (!campaignId && !isPublicBuilder) {
    history.push(generatePath(ROUTES.CAMPAIGN, { campaignId, clientId: clientIdParam }));
  }

  const getFlyerInfo = async () => {
    if (isPublicBuilder) {
      setFlyerInfo(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const flyerData = await getCampaignFlyerData(Number.parseInt(campaignId));
      const {
        campaignFlyerInfo,
        campaign: { selfServeData },
      } = flyerData;

      if (selfServeData && selfServeData.length && selfServeData[0].qrCodeLink) {
        setIsQrCodeExist(true);
      }
      if (campaignFlyerInfo) {
        setFlyerInfo(campaignFlyerInfo);
      } else {
        setFlyerInfo(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFlyerInfo();
  }, [campaignId]);

  return {
    isLoading,
    flyerInfo,
    pageState: getPageState(),
    getFlyerInfo,
    isQrCodeExist,
    campaignId,
  };
};
